import axiosInstance from "../../api/axiosInstance";

export const fetchControlledSetNumbersAPI = async (tournamentId) => {
  const setNumbers = await axiosInstance.get(
    `controlledSetNumber/get-controlled-set-numbers-for-one-tournament/${tournamentId}`
  );

  return setNumbers.data;
};

export const addControlledSetNumberAPI = async (
  adminId,
  tournamentId,
  setNumber
) => {
  const addedSetNumbers = await axiosInstance.post(
    "controlledSetNumber/assign-set-number",
    {
      adminId,
      tournamentId,
      setNumber,
    }
  );

  return addedSetNumbers.data;
};

export const removeControlledSetNumberAPI = async (
  adminId,
  tournamentId,
  setNumber
) => {
  const removedSetNumbers = await axiosInstance.post(
    "controlledSetNumber/remove-set-number",
    {
      adminId,
      tournamentId,
      setNumber,
    }
  );

  return removedSetNumbers.data;
};
